"use strict";

exports["default"] = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-middleware/node_modules/babel-runtime/helpers/class-call-check.js
// module id = 814
// module chunks = 1 2 3